import { createStore, applyMiddleware, compose } from "redux";
import {thunk} from "redux-thunk";
import rootReducer from "./reducers";
import { loadAuthSession, pickAccessToken, withIamTokenPrefix } from "../helpers/authStorage.helper";
import { setAuthToken } from "../helpers/request.helper";
import { setTenantId } from "../utils/requestHeaders";
import {
    installAuthDebugConsole,
    logAuthDebug,
} from "../helpers/authDebug.helper";

const savedAuth = loadAuthSession();
const savedToken = withIamTokenPrefix(
    pickAccessToken(savedAuth?.user || {}),
    savedAuth?.userType
);

if (savedToken) {
    setAuthToken(savedToken);
}
if (savedAuth?.activeTenantId || savedAuth?.tenantId) {
    setTenantId(savedAuth.activeTenantId || savedAuth.tenantId);
} else {
    setTenantId(null);
}

const initialState = savedAuth
    ? {
        authentication: {
            loggedIn: true,
            loading: false,
            error: null,
            user: savedAuth.user || {},
            userType: savedAuth.userType || null,
            tenantId: savedAuth.tenantId || null,
            activeTenantId: savedAuth.activeTenantId || null,
            activeTenantName: savedAuth.activeTenantName || null,
            roles: savedAuth.roles || [],
            permissions: savedAuth.permissions || [],
        },
    }
    : {};

const composedEnhancer = compose(applyMiddleware(thunk))

const store = createStore(
    rootReducer,
    initialState,
    composedEnhancer
);

installAuthDebugConsole(() => store.getState()?.authentication || {});
if (savedAuth?.loggedIn) {
    logAuthDebug(savedAuth, "IDP Session Restore");
}

export default store;
